import {
    FETCH_EXTERNAL_PRACTITIONER_LIST_REQUEST,
    FETCH_EXTERNAL_PRACTITIONER_LIST_SUCCESS,
    FETCH_EXTERNAL_PRACTITIONER_LIST_FAILURE,
  } from "./FetchExternalPractitionerTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchExternalPractitionerListRequest = () => {
    return {
      type: FETCH_EXTERNAL_PRACTITIONER_LIST_REQUEST,
    };
  };
  
  export const fetchExternalPractitionerListSuccess = (externalPractitionerList) => {
    return {
      type: FETCH_EXTERNAL_PRACTITIONER_LIST_SUCCESS,
      payload: externalPractitionerList,
    };
  };
  
  export const fetchExternalPractitionerListFailure = (error) => {
    return {
      type: FETCH_EXTERNAL_PRACTITIONER_LIST_FAILURE,
      payload: error,
    };
  };
  
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchExternalPractitionerList = (payload) => {
    //cancel previous request if multiple hits done.
     cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "practise/externalpractitioner/list/fetch?search_key=" + payload.search_key + "&sort_by=" +
    payload.sortBy +  "&page=" + payload.page + "&pageSize=10";

    return async (dispatch) => {
      dispatch(fetchExternalPractitionerListRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
  
        const externalPractitionerList = response.data.data;
        dispatch(fetchExternalPractitionerListSuccess(externalPractitionerList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchExternalPractitionerListFailure(errorMsg));
      }
    };
  };
  